<template>
<div class="activityGoodsEditDialog">
    <el-dialog @close='cancel' title="快捷设置" :visible.sync="dialogVisible" width="1000px">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
            <div class="list bgc">
                <div class="result-list btn-operate-list bgc">
                    <div class="tableData">
                        <div class="lengdeList box">
                            <span class="lengdeName blod innerbox imageTextBox tr">商品名称</span>
                            <span class="lengdeName blod innerbox specs">商品规格</span>
                            <span class="lengdeName blod innerbox">销售价格（￥）</span>
                            <span class="lengdeName blod innerbox">划线价格（￥）</span>
                            <span class="lengdeName blod innerbox">商品库存</span>
                            <span class="lengdeName blod innerbox tr">商品佣金（%）</span>
                        </div>
                        <div class="listbox">
                            <div class="listInnerBox">
                                <div v-for="(obj,index) in item.tableData" :key="index">
                                    <div class="box outbox" v-if="obj.isspecs!=1">
                                        <span class="innerbox imageTextBox">
                                            <el-form-item :prop="'tableData.' + index + '.productname'" :rules='rules.productname'>
                                                <el-input type="textarea" v-model="obj.productname" placeholder="请输入商品名称" clearable maxlength="40"></el-input>
                                            </el-form-item>
                                        </span>
                                        <span class="innerbox specs required">
                                            <el-form-item :prop="'tableData.' + index + '.specs'">
                                                <el-input type="textarea" v-model="obj.specs" placeholder="请输入商品规格" clearable maxlength="20"></el-input>
                                            </el-form-item>
                                        </span>
                                        <span class="innerbox required">
                                            <el-form-item :prop="'tableData.' + index + '.saleprice'" :rules='rules.saleprice'>
                                                <el-input v-model.trim="obj.saleprice" placeholder="请输入销售价格" clearable></el-input>
                                            </el-form-item>
                                        </span>
                                        <span class="innerbox">
                                            <el-form-item :prop="'tableData.' + index + '.uprice'" :rules='rules.uprice'>
                                                <el-input v-model.trim="obj.uprice" placeholder="请输入划线价格" clearable></el-input>
                                            </el-form-item>
                                        </span>
                                        <span class="innerbox">
                                            <el-form-item :prop="'tableData.' + index + '.stockcount'" :rules='rules.stockcount'>
                                                <el-input v-model.trim="obj.stockcount" placeholder="空为不限制" clearable></el-input>
                                            </el-form-item>
                                        </span>
                                        <span class="innerbox">
                                            <el-form-item :prop="'tableData.' + index + '.brokeragerate'" :rules='rules.brokeragerate'>
                                                <el-input v-model.trim="obj.brokeragerate" placeholder="请输入商品佣金" clearable></el-input>
                                            </el-form-item>
                                        </span>
                                    </div>
                                    <div class="contentBox" v-if="obj.isspecs==1 && obj.zproductlist.length">
                                        <span class="box innerbox imageTextBox box1">
                                            <el-form-item :prop="'tableData.' + index + '.productname'" :rules='rules.productname'>
                                                <el-input type="textarea" v-model="obj.productname" placeholder="请输入商品名称" clearable maxlength="40"></el-input>
                                            </el-form-item>
                                        </span>
                                        <div>
                                            <div class="box box2">
                                                <span class="innerbox specs required">
                                                    <el-form-item :prop="'tableData.' + index + '.specs'">
                                                        <el-input type="textarea" v-model="obj.specs" placeholder="请输入商品规格" clearable maxlength="20"></el-input>
                                                    </el-form-item>
                                                </span>
                                                <span class="innerbox required">
                                                    <el-form-item :prop="'tableData.' + index + '.saleprice'" :rules='rules.saleprice'>
                                                        <el-input v-model.trim="obj.saleprice" placeholder="请输入销售价格" clearable></el-input>
                                                    </el-form-item>
                                                </span>
                                                <span class="innerbox">
                                                    <el-form-item :prop="'tableData.' + index + '.uprice'" :rules='rules.uprice'>
                                                        <el-input v-model.trim="obj.uprice" placeholder="请输入划线价格" clearable></el-input>
                                                    </el-form-item>
                                                </span>
                                                <span class="innerbox">
                                                    <el-form-item :prop="'tableData.' + index + '.stockcount'" :rules='rules.stockcount'>
                                                        <el-input v-model.trim="obj.stockcount" placeholder="空为不限制" clearable></el-input>
                                                    </el-form-item>
                                                </span>
                                                <span class="innerbox">
                                                    <el-form-item :prop="'tableData.' + index + '.brokeragerate'" :rules='rules.brokeragerate'>
                                                        <el-input v-model.trim="obj.brokeragerate" placeholder="请输入商品佣金" clearable></el-input>
                                                    </el-form-item>
                                                </span>
                                            </div>
                                            <div class="box box2" v-for="(obj2,idx) in obj.zproductlist" :key="idx">
                                            <span class="innerbox specs required">
                                                <el-form-item :prop="'tableData.' + index + '.zproductlist.'+ idx + '.specs'" :rules='rules.specs'>
                                                    <el-input type="textarea" v-model="obj2.specs" placeholder="请输入商品规格" clearable maxlength="20"></el-input>
                                                </el-form-item>
                                            </span>
                                                <span class="innerbox required">
                                                <el-form-item :prop="'tableData.' + index + '.zproductlist.'+ idx + '.saleprice'" :rules='rules.saleprice'>
                                                    <el-input v-model.trim="obj2.saleprice" placeholder="请输入销售价格" clearable></el-input>
                                                </el-form-item>
                                            </span>
                                                <span class="innerbox">
                                                <el-form-item :prop="'tableData.' + index + '.zproductlist.'+ idx + '.uprice'" :rules='rules.uprice'>
                                                    <el-input v-model.trim="obj2.uprice" placeholder="请输入划线价格" clearable></el-input>
                                                </el-form-item>
                                            </span>
                                                <span class="innerbox">
                                                <el-form-item :prop="'tableData.' + index + '.zproductlist.'+ idx + '.stockcount'" :rules='rules.stockcount'>
                                                    <el-input v-model.trim="obj2.stockcount" placeholder="空为不限制" clearable></el-input>
                                                </el-form-item>
                                            </span>
                                                <span class="innerbox">
                                                <el-form-item :prop="'tableData.' + index + '.zproductlist.'+ idx + '.brokeragerate'" :rules='rules.brokeragerate'>
                                                    <el-input v-model.trim="obj2.brokeragerate" placeholder="请输入商品佣金" clearable></el-input>
                                                </el-form-item>
                                            </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
    <div slot="footer" class="dialog-footer"  style="margin-top: 20px;">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureEdit()">确 定</el-button>
    </div>
    </el-dialog>
</div>
</template>

<script>
import {getEventProductListBySetting, uploadEventProductListBySetting } from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'activityGoodsEditDialog',
    data() {
        let validateBrokeragerate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        return {
            dialogVisible: false,
            item: {
                tableData: [],
            },
            param: {
                eventid: ''
            },
            rules: {
                productname: [
                    {required: true, message: '请输入商品名称', trigger: 'blur'}
                ],
                specs: [
                    {required: true, message: '请输入商品规格', trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品售价', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                uprice: [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                stockcount: [
                    {pattern: /^[1-9]\d*|0$/, message: '请输入整数', trigger: 'blur'}
                ],
                brokeragerate: [
                    {pattern: /^([0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的商品佣金(2位小数)', trigger: 'blur'},
                    {validator: validateBrokeragerate, trigger: 'blur'},
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(obj) {
            this.param.eventid = obj.eventid
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.$refs.ruleForm.clearValidate()
            this.dialogVisible = false
        },
        sureEdit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let list = []
                    let tmplist = this._.cloneDeep(this.item.tableData)
                    tmplist.forEach(obj => {
                        obj.stockcount = obj.stockcount ? obj.stockcount : 0
                        obj.limitcountbyorder = obj.limitcountbyorder ? obj.limitcountbyorder : 0
                        list.push(obj)
                        obj.zproductlist.forEach(obj2 => {
                            obj2.stockcount = obj2.stockcount ? obj2.stockcount : 0
                            obj2.limitcountbyorder = obj2.limitcountbyorder ? obj2.limitcountbyorder : 0
                            list.push(obj2)
                        })
                    })
                    let obj = {
                        eventid: this.param.eventid,
                        list: list
                    }
                    this._edit(obj)
                }
            })
        },
        _edit(obj) {
            this.setLoading(true)
            uploadEventProductListBySetting({
                data: obj,
                success: data => {
                    this.item.tableData = data.data.productlist
                    this.setLoading(false)
                    this.$emit('getList')
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getEventProductListBySetting({
                data: Object.assign({}, this.param),
                success: data => {
                    this.item.tableData = data.data.productlist
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.activityGoodsEditDialog {
    .list{
        .listbox{
            max-height: 500px;
            overflow-y: auto;
            width: calc(100% + 17px);
            .listInnerBox{
                width: 958px;
            }
        }
        .outbox{
            padding: 0 !important;
        }
        .outbox,.contentBox{
            .innerbox{
                height: 100px !important;
            }
        }
        .contentBox{
            background: #fff !important;
            display: flex;
            .box1{
                border-right: 1px solid $line !important;
                box-sizing: border-box;
                flex-grow: 0;
                display: flex;
                align-items: center;
                justify-content: center !important;
                height: auto !important;
            }
            .box+.box{
                border-top: 1px solid $line !important;
            }
            .box2{
                flex-grow: 1;
                box-sizing: border-box;
                .innerbox{
                    width: 20% !important;
                    min-width: 20%;
                    text-align: center;
                }
            }
        }
        .innerbox{
            padding: 0 12px;
            width: 15% !important;
        }
        .innerbox + .innerbox{
            border-left: 1px solid $line !important;
        }
        .innerbox.imageTextBox{
            width: 25% !important;
            min-width: 25%;
        }
        .innerbox.specs{
            width: 15% !important;
            text-align: center;
        }
        .is-required{
            display: flex;
            align-items: center;
            &:before{
                content: '*';
                color: red;
                margin-right: 10px;
            }
        }
        .box{
            padding: 0 !important;
        }
    }
    .el-dialog__footer{
        padding: 0 0 30px 0;
    }
    .dialog-footer{
        margin-top: 0 !important;
    }
    .el-button{
        margin-bottom: 0 !important;
    }
    .el-textarea__inner{
        line-height: 1;
    }
    textarea{
        resize:none;
    }
    .el-textarea .el-input__count {
        bottom: 8px;
        right: 6px;
        height: 20px;
        background: transparent;
    }
    .el-form-item{
        height: calc(100% - 52px);
        .el-form-item__content{
            height: 100%;
            .el-textarea{
                height: 100%;
                textarea{
                    height: 100%;
                }
            }
        }
    }
}
</style>
